<template>
    <div>
        <div class="container clear-top" id="main">
            <navigation></navigation>
            <br>
            <br>
            <br>
            <br>
            <main role="main">
                <div class="row">
                    <div class="col-sm-4">
                        Usuário(a): {{ user.fullname }}
                        <br/>
                        <button class="btn btn-primary" type="button" @click="logout()"><v-icon name="sign-out-alt"></v-icon>&nbsp;&nbsp;Sair</button>
                    </div>
                    <div class="col-sm-8 col-xs-12">
                        <a :href="'/'"><img class="logo float-right" :src="logo" alt="Logo"></a>
                    </div>
                </div>
                <br>
                <router-view></router-view>
            </main>
        </div>
        <br>
        <br>
        <custom-footer></custom-footer>
    </div>
</template>

<script>
    import Navigation from './../components/Navigation';
    import CustomFooter from './../components/CustomFooter';
    import { mapGetters } from 'vuex'
    import Lockr from 'lockr';
    import Logo from './../assets/logo.png';

    export default {
        name: 'controller',
        data(){
            return {
                logo: Logo,
                user: Lockr.get('user') || 'N/A'
            }
        },
        components: {
            CustomFooter,
            Navigation
        },
        methods: {
            logout(){
                Lockr.flush();        
                this.$router.push({name: 'Login'});
            },
        }
    }
</script>

<style>
    @media (min-width: 480px) {
        .botao {
            text-align: left;
        }
    }

    @media (max-width: 480px) {

        .botao {
            text-align: center;
        }
    }

    .noheaderspace{
		margin-top: -5%;
	}

    .comment{
        margin-bottom: 1%;
    }

    .whiteselect{
        background-color: white;
    }

    .logo{
        height: 12vh;
        width: auto;
    }
</style>